/**
 * How GeoNexora signs people in, read at start from `/auth-config.json` (served next to
 * the app, so one image works for every environment):
 *
 *   { "mode": "legacy" }                                  username and password, as before
 *   { "mode": "ums",                                      through UMS (Veramenta docs/en/24, 59)
 *     "umsUrl": "https://auth.veralytiq.com",
 *     "authority": "https://veralytiq.ciamlogin.com/<directory id>",
 *     "knownAuthorities": ["veralytiq.ciamlogin.com"],
 *     "clientId": "<GeoNexora's app registration>",
 *     "scopes": ["api://<UMS API>/access"] }
 *
 * A missing or unreadable file means the old login.
 */
export interface AuthConfig {
  mode: 'legacy' | 'ums';
  umsUrl?: string;
  authority?: string;
  knownAuthorities?: string[];
  clientId?: string;
  scopes?: string[];
  redirectUri?: string;
}

let loaded: Promise<AuthConfig> | null = null;

export function loadAuthConfig(): Promise<AuthConfig> {
  if (!loaded) {
    loaded = fetch('/auth-config.json', { cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : { mode: 'legacy' }))
      .then((c: AuthConfig) => (c && c.mode === 'ums' && c.umsUrl && c.clientId && c.authority ? c : { mode: 'legacy' as const }))
      .catch(() => ({ mode: 'legacy' as const }));
  }
  return loaded;
}

/** For tests. */
export function resetAuthConfig(): void {
  loaded = null;
}
